/**
 * This is table-settings script.js file
 */

import { Sortable } from '@shopify/draggable';

export default {
    name  : 'VTableSettings',
    props : {
        value : {
            type     : Array,
            required : true
        }
    },
    /**
     * @override
     */
    data() {
        return {
            cols : []
        };
    },
    /**
     * Se asigna a cols las columnas de la tabla
     */
    created() {
        setTimeout(() => {
            this.cols = this.value;
        }, 50);
    },
    /**
     * @override
     */
    mounted() {
        const sortable = new Sortable(document.querySelectorAll('#js-list-columns-sortable'), {
            draggable : 'li',
            handle: '.drag-item-child'
        });

        sortable.on('sortable:sorted', ({ oldIndex, newIndex }) => {
            this.$emit('input', this.move(this.value, oldIndex, newIndex));
        });
    },
    methods : {
        /**
         * Re-ordenamos elementos dentro de un array de objetos
         * @param {Array} items Array de objetos
         * @param {Number} oldIndex Índice original del elemento a mover
         * @param {Number} newIndex  Índice final donde se quiere mover el elemento
         * @return {Array} Devuelve un array ordenado
         */
        move(items, oldIndex, newIndex) {
            const itemRemovedArray = [
                ...items.slice(0, oldIndex),
                ...items.slice(oldIndex + 1, items.length)
            ];

            const newColsOrder = [
                ...itemRemovedArray.slice(0, newIndex),
                items[oldIndex],
                ...itemRemovedArray.slice(newIndex, itemRemovedArray.length)
            ];
            this.$emit('colsChange', newColsOrder);

            return newColsOrder;
        },
        /**
         * Comprobamos el número de columnas activas.
         * En el caso de que el usuario des-seleccione todas se activará la primera por defecto
         * @param {Object} item Columna pulsada para activar/desactivar
         * @override
         */
        check(item) {
            item.active = !item.active;
            const total = this.colsNormalized.filter( x => {
                return x.active === true;
            }).length;

            if (total < 1) {
                this.colsNormalized[0].active = true;
            }
            this.$emit('colsChange', this.colsNormalized);

        }
    },
    computed: {
        /**
         * Devolvemos las columnas de las tablas con nombres de campo que sean diferentes a guíon bajo (_) al principio
         * @return {Array} Columnas que no contengan _ al principio
         */
        colsNormalized() {
            return this.cols.filter( x => {
                return x.field.charAt(0) !== '_';
            });
        }
    }
};
